var TemplateLibraryImportView;

TemplateLibraryImportView = Marionette.ItemView.extend( {
	template: '#tmpl-kitbuilder-template-library-import',

	id: 'kitbuilder-template-library-import',

	ui: {
		uploadForm: '#kitbuilder-template-library-import-form'
	},

	events: {
		'submit @ui.uploadForm': 'onFormSubmit'
	},

	onFormSubmit: function( event ) {
		event.preventDefault();

		kitbuilder.templates.getLayout().showLoadingView();

		kitbuilder.ajax.send( 'import_template', {
			data: new FormData( this.ui.uploadForm[ 0 ] ),
			processData: false,
			contentType: false,
			success: function( data ) {
				kitbuilder.templates.getTemplatesCollection().add( data.item );

				kitbuilder.templates.showTemplates();
			},
			error: function( data ) {
				kitbuilder.templates.showErrorDialog( data );
			}
		} );
	}
} );

module.exports = TemplateLibraryImportView;
